import { apiGet, apiPut } from '../../framework/client';
import { ERROR_API_CALL_FAILED } from '../../../common/framework/constants';

export async function getAbaxClientSecret(customerId: string): Promise<{ abaxClientSecret: string }> {
    const response = await apiGet(`/api/abax/client-secret/${customerId}`);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function saveAbaxClientSecret(customerId: string, abaxClientSecret: string): Promise<{ success: number }> {
    const response = await apiPut(`/api/abax/client-secret/${customerId}`, { abaxClientSecret });

    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getAbaxClientId(customerId: string): Promise<{ abaxClientId: string }> {
    const response = await apiGet(`/api/abax/client-id/${customerId}`);

    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function saveAbaxClientId(customerId: string, abaxClientId: string): Promise<{ success: number }> {
    const response = await apiPut(`/api/abax/client-id/${customerId}`, { abaxClientId });

    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getAbaxVehicleUsage(
    customerId: string,
    abaxVehicleId: string,
): Promise<{ ok: true }> {
    const queryParams = { customerId, abaxVehicleId };
    const response = await apiGet('/api/abax/vehicle-usage', queryParams);

    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}